"use strict";
exports.__esModule = true;
exports.useTrelloIframe = void 0;
var react_1 = require("react");
var useTrelloIframe = function (options) {
    var iframe = (0, react_1.useState)(window.TrelloPowerUp.iframe(options))[0];
    return iframe;
};
exports.useTrelloIframe = useTrelloIframe;
//# sourceMappingURL=iframe.js.map